export const hasEllipsis = (element: HTMLElement) => element.offsetHeight < element.scrollHeight
